var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"page-spacing"},[_c('v-col',{attrs:{"cols":"12"}},[_c('log-info')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }